<template>
  <div class="plan-container">
    <!-- light plan -->
    <div class="plan-box" :class="{'selected-plan': user.billing===1}">
      <div class="header-plan -light">
        <h2>ライトプラン</h2>
      </div>
      <div class="body-plan">
        <p class="taisyo">
          （想定対象）<br>
          部分使用されたい／自社で管理されたい
        </p>
        <p class="kingaku">
          ￥50,000 - <br>
          <span class="zeinuki">
            （税抜き）
          </span>
        </p>
        <p class="kinou">
          日程調整：∞ (無制限)<br>
          ロボ機能：一部制限有<br><br>
          運用代行：　　無　　
        </p>
      </div>
      <div class="footer-plan">
        <button class="button is-fullwidth is-primary"
           @click="changeSelectBilling(1)" :disabled="user.billing!==1&&user.permission!==0||user.billing===1">
           <template v-if="user.billing===1">
             現在選択中のプランです
           </template>
           <template v-else>
             プランを切り替える
           </template>
        </button>
      </div>
    </div>
    <!-- standard plan -->
    <div class="plan-box" :class="{'selected-plan': user.billing===2}">
      <div class="header-plan -std">
        <h2>スタンダードプラン</h2>
      </div>
      <div class="body-plan">
        <p class="taisyo">
          （想定対象）<br>
          全機能を使いたい／運用は全て頼みたい
        </p>
        <p class="kingaku">
          ￥200,000 - <br>
          <span class="zeinuki">
            （税抜き）
          </span>
        </p>
        <p class="kinou">
          日程調整：∞ (無制限)<br>
          ロボ機能：∞ (無制限)<br><br>
          運用代行：　　有　　
        </p>
      </div>
      <div class="footer-plan">
        <button class="button is-fullwidth is-primary"
           @click="changeSelectBilling(2)" :disabled="user.billing!==2&&user.permission!==0||user.billing===2">
           <template v-if="user.billing===2">
             現在選択中のプランです
           </template>
           <template v-else>
             プランを切り替える
           </template>
        </button>
      </div>
    </div>
    <!-- juryou plan -->
    <div class="plan-box" :class="{'selected-plan': user.billing===3}">
      <div class="header-plan -juryou">
        <h2>従量課金プラン</h2>
      </div>
      <div class="body-plan">
        <p class="taisyo">
          （想定対象）<br>
          試しに使用してみたい／使用頻度が限られる
        </p>
        <p class="kingaku">
          ￥{{masterBilling.pay_per_use_plan}}
          <span class="zeinuki">
            + ロボの対応数分課金<br>（税抜き）
          </span>
        </p>
        <p class="kinou">
          日程調整：∞ (無制限)<br>
          ロボ機能：∞ (無制限)<br>
          運用代行：　　無　　<br>
          採用業務関連機能：制限有
        </p>
      </div>
      <div class="footer-plan">
        <button class="button is-fullwidth is-primary"
           @click="changeSelectBilling(3)" :disabled="user.billing!==3&&user.permission!==0||user.billing===3">
           <template v-if="user.billing===3">
             現在選択中のプランです
           </template>
           <template v-else>
             プランを切り替える
           </template>
        </button>
      </div>
    </div>
    <section>
      <b-modal width="680px" :active.sync="isCardModalActive">
        <div class="card" style="border-radius: 5px;">
          <header class="card-header">
            <p class="card-header-title" v-if="this.billing!==0">
              「{{plan}}」に切り替えますがよろしいでしょうか？
            </p>
            <div class="card-header-title" v-if="this.billing===0">
              「{{plan}}」への切り替えについて
            </div>
          </header>
          <div class="card-content">
            <div>
              <b-message type="is-danger" has-icon v-if="this.billing!==0">
                <h2 style="font-size: 18px;"><b>下記を良くお読み頂きまして、同意される方は「はい」を押下してください。</b></h2>
                <p>
                  1. 切替後は翌月まで変更不可となります。
                  <br>2. プランは切り替えた当日より、有効になります。
                  <br>3. 料金はプランを変更した翌月から変更となります。
                  <br>4. 従量課金プランには上限額があります。<br> 課金額が上限額を超えると一部制限があります。
                  <br>5. プラン開始時の上限設定は<b>5,000円</b>になります。
                  <br>6. 上限額を超えた場合でもお支払金額は上限額分のみ請求となります。
                  <br>7. 上限額を下回る場合、お支払金額は合計額を元に請求いたします。
                </p>
              </b-message>
              <hr>
              前回変更年月：{{user.billingYYYYMM}}
            </div>
          </div>
          <footer class="card-footer" v-if="this.billing!==0">
            <a class="card-footer-item" @click="clickChangeBilling()">はい</a>
            <a class="card-footer-item" @click="isCardModalActive = false">いいえ</a>
          </footer>
        </div>
      </b-modal>
    </section>
  </div>
</template>

<script>
import ModalSelectBilling from '@/components/ui/ModalSelectBilling'
export default {
  components: {
    ModalSelectBilling
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    masterBilling: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      isCardModalActive: false,
      billing: 0
    }
  },
  computed: {
    plan () {
      if (this.billing === 1) return 'ライトプラン'
      else if (this.billing === 2) return 'スタンダードプラン'
      else if (this.billing === 3) return '従量課金プラン'
    }
  },
  methods: {
    changeSelectBilling (billing) {
      this.isCardModalActive = true
      this.billing = billing
    },
    clickChangeBilling () {
      this.setProfile()
      // 遅延送付
      setTimeout(() => {this.planNotify()}, 3000)
      this.isCardModalActive = false
    },
    setProfile () {
      let data = {
        'billing': this.billing
      }
      // 従量課金のばあいは初期値で上限設定を入れる
      if (this.billing === 3) {
        data.upper_price = 5000
      }
      this.$emit('setProfile', data)
    },
    planNotify () {
      let sendClient = {
        name: 'plan_chenge_client',
        to: user.email,
      }
      this.$emit('planNotify', sendClient)
      let sendSales = {
        name: 'plan_chenge_sales',
        to: process.env.SALES_EMAIL,
      }
      this.$emit('planNotify', sendSales)
    },
  }
}
</script>

<style lang="scss" scoped>
.plan-container {
  display: flex;
  flex-wrap: nowrap !important;
  overflow: scroll;
  justify-content: center;
  padding: 24px;
  overflow: auto;
}
.plan-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-width: 264px;
  width: 320px;
  padding: 8px;
  .header-plan {
    width: 100%;
    text-align: center;
    border-radius: 8px;
    margin-bottom: 8px;
    h2 {
      font-size: 22px;
      font-weight: 600;
      color: white;
      padding: 16px;
      margin: 0;
    }
  }
  .body-plan {
    width: 100%;
    text-align: center;
    background: #EEE;
    border-radius: 8px;
    margin-bottom: 8px;
    padding: 8px;
    color: #162c5d;
    .taisyo {
      color: #EE2C98;
      font-size: 18px;
      margin-bottom: 24px;
    }
    .kingaku {
      font-size: 24px;
      font-weight: 600;
    }
    .zeinuki {
      font-size: 14px;
    }
    .kinou {
      font-size: 16px;
    }
  }
  .footer-plan {
    width: 100%;
    text-align: center;
  }
}

.-light {
  background: #99E;
}
.-std {
  background: #162c5d;
}
.-juryou {
  background: #bf9000;
}
.selected-plan {
  border: solid 4px #a22;
  border-radius: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Setting/Billing/PlanView.vue